__turbopack_context__.v({
  "checkbox": "PasswordField-module-scss-module__RwYFOq__checkbox",
  "field": "PasswordField-module-scss-module__RwYFOq__field",
  "hasErrors": "PasswordField-module-scss-module__RwYFOq__hasErrors",
  "hidden": "PasswordField-module-scss-module__RwYFOq__hidden",
  "line-break": "PasswordField-module-scss-module__RwYFOq__line-break",
  "text-align_center": "PasswordField-module-scss-module__RwYFOq__text-align_center",
});
